import styles from './SIZ.module.css';
import Button from '../../../components/Button/Button';
import {Modal} from '../../../components/Modals/Modal';
import {useState} from 'react';
import useFillSelect from '../../../hooks/useFillSelect.hook';
import {
	getAllMaterialTypesUrl,
	getAllNormsUrl,
	getAllUsersUrl
} from '../../../helpers/constants';
import {ManageTypes} from '../../../components/Modals/ManageTypes/ManageTypes';
import {ManageNorms} from '../../../components/Modals/ManageNorms/ManageNorms';
import {DeleteSIZ} from '../../../components/Modals/DeleteSIZ/DeleteSIZ';
import {CreateSIZ} from '../../../components/Modals/CreateSIZ/CreateSIZ';
import {SurfaceBar} from '../../../components/SurfaceBar/SurfaceBar';
import {SIZIssued} from './SIZIssued/SIZIssued';
import {SIZNeedTable} from './SIZNeedTable/SIZNeedTable';
import {SIZChart} from './SIZChart/SIZChart';


export function SIZ () {
	const [activeTab, setActiveTab] = useState('chart');
	const [presetMaterialTypeId, setPresetMaterialTypeId] = useState(null);
	const [isManageTypesOpen, setIsManageTypesOpen] = useState(false);
	const [isManageNormsOpen, setIsManageNormsOpen] = useState(false);
	const [refreshKey, setRefreshKey] = useState(0);
	const [selectedSIZ, setSelectedSIZ] = useState(null);
	const [isCreateModalOpen, setCreateModalOpen] = useState(false);
	const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

	const {
		options: optionsTypes,
		itemDict: typesDict,
		getItems: getTypes
	} = useFillSelect({
		endpoint: getAllMaterialTypesUrl,
		labelField: 'title',
		fetchOnMount: false
	});

	const {
		options: optionsNorms,
		itemDict: normsDict,
		getItems: getNorms
	} = useFillSelect({
		endpoint: getAllNormsUrl,
		labelField: 'title',
		fetchOnMount: false
	});

	const {
		options: optionsUser,
		itemDict: userDict,
		getItems: getUsers,
		loading: loadingUsers
	} = useFillSelect({
		endpoint: `${getAllUsersUrl}/`,
		labelBuilder: (u) => {
			return [u.last_name, u.name, u.father_name].filter(Boolean).join(' ');
		},
		fetchOnMount: false
	});

	const toKey = (v) => (v === null || v === undefined || v === '' ? null : String(v));
	const normalizeForEditor = (r) => ({
		...r,
		user_id: toKey(r.user_id ?? r.user?.id),
		material_type_id: toKey(r.material_type_id ?? r.material_type?.id)
	});

	const openModalTypes = () => {
		if (optionsTypes.length === 0) getTypes();
		setIsManageTypesOpen(true);
	};

	const openModalNorms = () => {
		if (optionsNorms.length === 0) getNorms();
		if (optionsTypes.length === 0) getTypes();
		setIsManageNormsOpen(true);
	};

	const openCreateModal = () => {
		if (optionsTypes.length === 0) getTypes();
		if (optionsUser.length === 0) getUsers();
		setSelectedSIZ(null);
		setCreateModalOpen(true);
	};

	const handleEditIssued = (record) => {
		if (optionsTypes.length === 0) getTypes();
		if (optionsUser.length === 0) getUsers();
		setSelectedSIZ(normalizeForEditor(record));
		setCreateModalOpen(true);
	};

	const handleDeleteIssued = (record) => {
		setSelectedSIZ(record);
		setDeleteModalOpen(true);
	};

	const handleGoToTable = (materialTypeId) => {
		setPresetMaterialTypeId(materialTypeId);
		setActiveTab('need');
	};

	const tabs = [
		{id: 'chart', label: 'График'},
		{id: 'issued', label: 'Выдано'},
		{id: 'need', label: 'Потребность'}
	];

	const managementActions = (
		<>
			<Button onClick={openCreateModal}>
				Выдать СИЗ
			</Button>
			<Modal isOpen={isCreateModalOpen} onClose={() => setCreateModalOpen(false)}>
				<CreateSIZ
					optionsUser={optionsUser}
					userDict={userDict}
					optionsTypes={optionsTypes}
					typesDict={typesDict}
					loadingUsers={loadingUsers}
					setCreateModalOpen={setCreateModalOpen}
					setRefreshKey={setRefreshKey}
					currentSIZ={selectedSIZ}
				/>
			</Modal>
			<Button onClick={openModalTypes}>
				Типы материалов
			</Button>
			<Modal isOpen={isManageTypesOpen} onClose={() => setIsManageTypesOpen(false)}>
				<ManageTypes
					optionsTypes={optionsTypes}
					typesDict={typesDict}
					getTypes={getTypes}
				/>
			</Modal>
			<Button onClick={openModalNorms}>
				Нормы
			</Button>
			<Modal isOpen={isManageNormsOpen} onClose={() => setIsManageNormsOpen(false)}>
				<ManageNorms
					optionsNorms={optionsNorms}
					normsDict={normsDict}
					optionsTypes={optionsTypes}
					getNorms={getNorms}
				/>
			</Modal>
		</>
	);

	return (
		<div className={styles.siz}>
			<div className={styles.outer_table}>
				<div className={styles.tabsBlock}>
					<SurfaceBar
						actions={managementActions}
						tabs={tabs}
						activeTab={activeTab}
						onTabChange={setActiveTab}
					/>
					<div className={styles.tabContentTight}>
						{activeTab === 'issued' && (
							<SIZIssued
								refreshKey={refreshKey}
								onEdit={handleEditIssued}
								onDelete={handleDeleteIssued}
							/>
						)}
						{activeTab === 'need' && (
							<SIZNeedTable
								presetMaterialTypeId={presetMaterialTypeId}
								onIssued={() => setRefreshKey((prev) => prev + 1)}
							/>
						)}
						{activeTab === 'chart' && (
							<SIZChart onGoToTable={handleGoToTable} />
						)}
					</div>
				</div>
			</div>
			<Modal isOpen={isDeleteModalOpen} onClose={() => setDeleteModalOpen(false)}>
				<DeleteSIZ
					SIZ={selectedSIZ}
					setDeleteModalOpen={setDeleteModalOpen}
					setRefreshKey={setRefreshKey}
				/>
			</Modal>
		</div>
	);
}
